import { ListItemText, ListItemTextProps } from '@mui/material';
import { useThemeUtils } from 'contexts/ThemeContext/hooks/useThemeUtils';
import React from 'react';

export const SettingsListItemText = ({ inset, ...muiProps }: ListItemTextProps) => {
  const { theme } = useThemeUtils();
  const insetStyle = inset ? { paddingLeft: theme.spacing(4.5) } : {};
  return <ListItemText sx={{ ...muiProps.sx, ...insetStyle }} {...muiProps} />;
};
